import axios from "axios";
import { API } from "../constant";

export const getSyllables = async ({ type }) => {
  let url = `/syllable`;

  return await axios
    .get(`${API}${url}`)
    .then((res) => res)
    .catch((err) => console.error(err));
};
